module.exports = __webpack_public_path__ + "assets/db0c81f0eae759f2bbfe792c2c3610c4.mp3";


/*****************
 ** WEBPACK FOOTER
 ** /Users/kevinduarte/SG/roc2/engine/public-src/spingames/panel/sounds/buttons/autos/auto_25.mp3
 ** module id = 35
 ** module chunks = 0
 **/